import { z } from "zod";

import { createEventFactory } from "../gtm";

export const signUpNewsletterWebsiteGtmEvent = createEventFactory(
  "sign_up_newsletter_website",
  z.object({
    email: z.email(),
  }),
);
